'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFolderOpen, iconFolderOpenTag } from '@ni/nimble-components/dist/esm/icons/folder-open';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFolderOpen };
export { iconFolderOpenTag };
export const NimbleIconFolderOpen = wrap(IconFolderOpen);